import React from 'react'
import { useSelector } from 'react-redux'
import { Typography } from '@material-ui/core'
import {
  AdvancedMarker,
  AdvancedMarkerAnchorPoint,
  // eslint-disable-next-line
} from '@vis.gl/react-google-maps/dist/index.umd.js'
import missingMarkersData from './missingLots.json'
// import { CustomIcon } from '../../../../../apps/AppComponents/IconPicker/IconPicker'
import { setMarkerInfo } from '../../redux/myMapsSlice'
import { isWithinRadius } from '../../helpers/helpers'

const MissingLotMarker = ({ latitude, longitude, dispatch, zoom }) => {
  const [missingMarkers, updateMissingMarkers] = React.useState([])
  React.useEffect(() => {
    const nearestParking = isWithinRadius(
      latitude,
      longitude,
      missingMarkersData,
    )
    updateMissingMarkers(nearestParking)
  }, [latitude, longitude, zoom])
  return (
    <div>
      {missingMarkers?.map((missingMarker) => (
        <MissingLotAdvancedMarker
          key={missingMarker['MAP ID']}
          missingMarker={missingMarker}
          dispatch={dispatch}
        />
      ))}
    </div>
  )
}

const MissingLotAdvancedMarker = ({ missingMarker, dispatch }) => {
  const [setActive, updateSetActive] = React.useState(false)
  const { markerInfo } = useSelector((s) => s.maps)
  const handleUpdateShowCard = () => {
    dispatch(setMarkerInfo(missingMarker))
  }
  React.useEffect(() => {
    if (markerInfo && markerInfo['MAP ID'] === missingMarker['MAP ID']) {
      updateSetActive(!setActive)
    } else {
      updateSetActive(false)
    }
  }, [markerInfo])
  return (
    <AdvancedMarker
      key={missingMarker['MAP ID']}
      position={{ lat: missingMarker?.Lat, lng: missingMarker?.Long }}
      title={missingMarker['Property Name']}
      clickable
      onClick={handleUpdateShowCard}
      anchorPoint={AdvancedMarkerAnchorPoint.TOP}
      style={{ zIndex: 9999 }}
    >
      <div
        style={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          background: 'white',
          padding: '0px 3px',
        }}
      >
        <Typography variant="body1" style={{ fontSize: 13 }}>
          {missingMarker.Lot}
        </Typography>
      </div>
    </AdvancedMarker>
  )
}

export default MissingLotMarker
